import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LightbulbOnIcon from 'icons/LightbulbOn.icon';

import './DefaultSuggestedActionsEmptyState.styles.scss';

type DefaultSuggestedActionsEmptyStateProps = {
  className?: string;
  title?: string;
};

const DefaultSuggestedActionsEmptyState: React.FC<
  DefaultSuggestedActionsEmptyStateProps
> = (props) => {
  const { t } = useTranslation();

  const { children, className, title = t('suggestedActionsEmpty') } = props;

  const classes = classNames(
    'default-suggested-actions-empty-state',
    className,
  );

  return (
    <div className={classes}>
      <span className="icon">
        <LightbulbOnIcon />
      </span>

      <p className="title">{title}</p>

      {children}
    </div>
  );
};

export default DefaultSuggestedActionsEmptyState;
